export default __webpack_public_path__ + "static/media/driver-recomends.47255470.png";